var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFurniture4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.627,
    height: 52.806,
    viewBox: "0 0 26.627 52.806",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7758",
    "data-name": "Grupo 7758",
    transform: "translate(-63.657 -46.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7757",
    "data-name": "Grupo 7757",
    transform: "translate(63.81 65.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8614",
    "data-name": "Caminho 8614",
    d: "M40.873,27.26H16.539a1,1,0,0,1-.995-.995V22.246a1,1,0,0,1,.995-.995H40.873a1,1,0,0,1,.995.995v4.019A1,1,0,0,1,40.873,27.26ZM17.534,25.27H39.878v-2.03H17.534Z",
    transform: "translate(-15.544 -21.251)",
    stroke: "#fff",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_22",
    "data-name": "Uni\\xE3o 22",
    d: "M18.831,52.507a1.852,1.852,0,0,1-1.854-1.846V47.922H9.346v2.739A1.848,1.848,0,0,1,7.5,52.507H5.625A1.848,1.848,0,0,1,3.78,50.661v-2.74A3.893,3.893,0,0,1,0,44.034V23.785a1,1,0,0,1,.995-.994H25.329a.994.994,0,0,1,.994.994V44.034a3.893,3.893,0,0,1-3.771,3.886v2.74A1.852,1.852,0,0,1,20.7,52.507Zm.136-1.99h1.6V47.922h-1.6Zm-13.2,0H7.356V47.922H5.77ZM1.99,44.034a1.9,1.9,0,0,0,1.9,1.9H22.436a1.9,1.9,0,0,0,1.9-1.9V24.781H1.99ZM3.073,32.1V27.977a2.381,2.381,0,0,1,4.763,0V32.1a2.381,2.381,0,0,1-4.763,0Zm1.99-4.128V32.1a.392.392,0,0,0,.783,0V27.977a.392.392,0,0,0-.783,0ZM1,20.761a1,1,0,0,1-1-1V3.888A3.892,3.892,0,0,1,3.89,0H22.44a3.892,3.892,0,0,1,3.887,3.887V19.766a1,1,0,0,1-1,1ZM1.993,3.888V18.771H24.337V3.888a1.9,1.9,0,0,0-1.9-1.9H3.89A1.9,1.9,0,0,0,1.993,3.888Zm1.08,10.69V10.45a2.381,2.381,0,1,1,4.763,0v4.128a2.381,2.381,0,0,1-4.763,0Zm1.99-4.128v4.128a.391.391,0,1,0,.783,0V10.45a.391.391,0,1,0-.783,0Z",
    transform: "translate(63.807 46.371)",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2243",
    "data-name": "Ret\\xE2ngulo 2243",
    width: 26.324,
    height: 4.637,
    rx: 2.318,
    transform: "translate(63.81 65.965)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture4);
export default __webpack_public_path__ + "static/media/furniture-4.c2e4f5d91b098cd4bb191d62e66a3dff.svg";
export { ForwardRef as ReactComponent };